(function() { window.GUID_5301700c_eb67_4eeb_b94a_9ce6ad292b3e = { getGuid: function() { return "5301700c-eb67-4eeb-b94a-9ce6ad292b3e"; } }; })();
var CS;
(function (CS) {
    var Enums;
    (function (Enums) {
        let KeyCode;
        (function (KeyCode) {
            KeyCode[KeyCode["Enter"] = 13] = "Enter";
            KeyCode[KeyCode["Shift"] = 16] = "Shift";
            KeyCode[KeyCode["Ctrl"] = 17] = "Ctrl";
            KeyCode[KeyCode["Escape"] = 27] = "Escape";
            KeyCode[KeyCode["SpaceBar"] = 32] = "SpaceBar";
            KeyCode[KeyCode["ArrowUp"] = 38] = "ArrowUp";
            KeyCode[KeyCode["ArrowDown"] = 40] = "ArrowDown";
            KeyCode[KeyCode["ArrowLeft"] = 37] = "ArrowLeft";
            KeyCode[KeyCode["ArrowRight"] = 39] = "ArrowRight";
            KeyCode[KeyCode["Add"] = 107] = "Add";
            KeyCode[KeyCode["Plus"] = 107] = "Plus";
            KeyCode[KeyCode["Subtract"] = 109] = "Subtract";
            KeyCode[KeyCode["Minus"] = 109] = "Minus";
            KeyCode[KeyCode["CtlrA"] = 400] = "CtlrA";
        })(KeyCode = Enums.KeyCode || (Enums.KeyCode = {}));
        let ItemSelectionMode;
        (function (ItemSelectionMode) {
            ItemSelectionMode[ItemSelectionMode["None"] = 0] = "None";
            ItemSelectionMode[ItemSelectionMode["Single"] = 1] = "Single";
            ItemSelectionMode[ItemSelectionMode["Multiple"] = 2] = "Multiple";
            ItemSelectionMode[ItemSelectionMode["MultipleToggle"] = 3] = "MultipleToggle";
        })(ItemSelectionMode = Enums.ItemSelectionMode || (Enums.ItemSelectionMode = {}));
        let SportEventType;
        (function (SportEventType) {
            SportEventType[SportEventType["League"] = 0] = "League";
            SportEventType[SportEventType["Tournament"] = 1] = "Tournament";
        })(SportEventType = Enums.SportEventType || (Enums.SportEventType = {}));
    })(Enums = CS.Enums || (CS.Enums = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-enums.js.map
